/**
 * EntityInvitations API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import {
  acceptEntityInvitation,
  cancelEntityInvitation,
  getEntityInvitation,
  listEntityInvitations,
  resendEntityInvitation,
} from "../generated/entity-invitations/entity-invitations";

import { wrapMethod } from "./utils";

export const entityInvitations = {
  /** @see listEntityInvitations */
  listEntityInvitations: wrapMethod(listEntityInvitations),

  /** @see getEntityInvitation */
  getEntityInvitation: wrapMethod(getEntityInvitation),

  /** @see cancelEntityInvitation */
  cancelEntityInvitation: wrapMethod(cancelEntityInvitation),

  /** @see resendEntityInvitation */
  resendEntityInvitation: wrapMethod(resendEntityInvitation),

  /** @see acceptEntityInvitation */
  acceptEntityInvitation: wrapMethod(acceptEntityInvitation),
} as const;

export type EntityInvitationsApi = typeof entityInvitations;
